// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__BoSTm","searchInput":"SearchBar_searchInput__sHAVW"};